import React, { useContext, useState, useRef, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";

import { FormGroup, Form, Input, Label, Button, Row, Col, Spinner, Alert } from "reactstrap";
import UserContext from "./UserContext";

const ValidLoginForm = () => {
    const [loading, setLoading] = useState(false);
    const { login, error, setError } = useContext(UserContext);
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    const formik = useFormik({
        initialValues: {
            username: "",
            password: "",
        },
        validationSchema: Yup.object({
            username: Yup.string().max(25, "Must be 25 characters or less").required("Required"),
            password: Yup.string().required("Required"),
        }),
        onSubmit: async (values) => {
            if (!isMounted.current) return;
            setLoading(true);
            setError(null);
            try {
                const result = await login(values.username, values.password);
                if (!result?.success && isMounted.current) {
                    formik.resetForm();
                }
            } catch (err) {
                console.error(err);
            } finally {
                if (isMounted.current) setLoading(false);
            }
        },
    });

    return (
        <section className="auth-page">
            {loading ? (
                <Spinner color="primary" />
            ) : (
                <Row className="justify-content-center m-0 w-100">
                    <Col
                        xs={12}
                        sm={10}
                        md={6}
                        lg={4}>
                        <div className="auth-card">
                            <Form onSubmit={formik.handleSubmit}>
                                <FormGroup>
                                    <Label htmlFor="username">Username</Label>
                                    <Input
                                        id="username"
                                        placeholder="enter username"
                                        name="username"
                                        type="text"
                                        autoComplete="username"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.username}></Input>
                                    {formik.touched.username && formik.errors.username ? <div style={{ color: "red" }}>{formik.errors.username}</div> : null}

                                    <Label htmlFor="password">password</Label>
                                    <Input
                                        id="password"
                                        placeholder="enter password here"
                                        name="password"
                                        type="password"
                                        autoComplete="current-password"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.password}></Input>
                                    {formik.touched.password && formik.errors.password ? <div style={{ color: "red" }}>{formik.errors.password}</div> : null}
                                </FormGroup>
                                <Button
                                    type="submit"
                                    color="success"
                                    disabled={loading}>
                                    Login
                                </Button>

                                <div style={{ marginTop: "0.75rem", fontSize: "0.9rem" }}>
                                    <Link to="/forgot-password">Forgot password?</Link>
                                </div>

                                <div style={{ marginTop: "0.4rem", fontSize: "0.9rem" }}>
                                    <Link to="/tenant/login">Tenant validation portal login</Link>
                                </div>
                            </Form>
                        </div>
                    </Col>
                </Row>
            )}
        </section>
    );
};

export default ValidLoginForm;
